const REACT_API_BASE_URL='http://localhost:2000'


export default REACT_API_BASE_URL;